import colors from '../../../../../../dashboard/styles/abstracts/colors.module.scss'

const styles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    border: `1px solid ${colors.inputBorder}`,
    borderRadius: '8px',
    boxShadow: state.isFocused ? '0 0 0 1px var(--brand-primary-light)' : 'none',
    cursor: 'pointer',
    '&:hover': {
      borderColor: state.isFocused ? 'var(--brand-primary-light)' : baseStyles.borderColor,
    },
    padding: '7px 16px',
    width: '142px'
  }),
  dropdownIndicator: baseStyles => ({
    ...baseStyles,
    color: colors.bodyText,
    padding: '0'
  }),
  indicatorContainer: baseStyles => ({
    ...baseStyles,
    padding: '0'
  }),
  indicatorSeparator: baseStyles => ({
    ...baseStyles,
    display: 'none'
  }),
  menu: baseStyles => ({
    ...baseStyles,
    border: `1px solid ${colors.inputBorder}`,
    borderRadius: '8px',
    boxShadow: 'none',
    left: '-25%',
    width: '208px',
    zIndex: '1303'
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    color: state.isFocused ? '#FFFFFF' : colors.headerText,
    cursor: 'pointer',
    backgroundColor: state.isFocused ? 'var(--brand-primary-light)' : 'transparent',
    fontSize: '0.9375rem',
    lineHeight: '160%',
    padding: state.isSelected ? '6px 32px' : '6px 32px 6px 60px'
  }),
  singleValue: baseStyles => ({
    ...baseStyles,
    color: colors.bodyText,
    fontSize: '0.9375rem',
    lineHeight: '18px',
    margin: '0'
  }),
  valueContainer: baseStyles => ({
    ...baseStyles,
    padding: '0'
  })
}

export default styles
